import React from 'react';
import axios from 'axios';

import { API_URL } from 'utils/config';

const Header = (props) => {
  const { layout, data } = props;
  const { title, identity, link, id } = data;
  const API_ENDPOINT = `${API_URL}/researches-issue/hits`;

  const ContentLayout = (
    <>
      <div className="l-issue__heading">
        <h3 className="l-issue__title">Q: 問題描述</h3>
        <p className="l-issue__text">{title}</p>
      </div>
      <div className="l-issue__footer">
        <div className="l-issue__subtext">提問人身份</div>
        <h4 className="l-issue__title">{identity}</h4>
      </div>
    </>
  );

  const handleClick = async (id) => {
    try {
      const response = await axios.post(`${API_ENDPOINT}/${id}`);
    } catch (err) {
      console.error('取得聚焦主題資料失敗：', err);
    }
  };

  return (
    <>
      <div
        className={`${
          layout === 'col' ? 'col-12 col-md-6 col-xl-4' : 'col-12'
        } d-flex align-items-stretch`}
      >
        <div
          className={`${
            layout === 'col'
              ? 'l-issue__item l-issue__item--btn'
              : 'l-issue__item'
          }`}
        >
          {ContentLayout}
          <a
            href={link}
            target="_blank"
            rel=" noreferrer"
            className="stretched-link"
            onClick={() => {
              handleClick(id);
            }}
          ></a>
        </div>
      </div>
    </>
  );
};

export default Header;
